export default "__VITE_ASSET__e27a1720__"